/*

Filters
=======

Collection of useful filters.

 */

angular.module('jv.Common.Filters', [])

.service('jvFilterService', [function() {
    var jvFilterService = {};

    /*
     * convertJavaFormatToMomentFormat
     * Convert Java-style date format strings to Moment-style format strings
     *
     * @param <dateTimeFormat> Java-style date or time format you want converted
     * @return <String> Moment-style date or time format
       ===========================================================================*/
    jvFilterService.convertJavaFormatToMomentFormat = function(dateTimeFormat) {
        // perform format conversions -- could probably cache the results somewhere
        var momentDateFormat = dateTimeFormat;
        momentDateFormat = momentDateFormat.replace('dd','DD').replace('d','D');
        momentDateFormat = momentDateFormat.replace('yyyy','YYYY').replace('yy','YY');
        momentDateFormat = momentDateFormat.replace('a','A').replace('EEEE','dddd');
        return momentDateFormat;
    };

    jvFilterService.convertJavaFormatToDatePickerFormat = function(dateTimeFormat) {
        var format = dateTimeFormat;
        if (format.contains("MMMMM")) {
            format = format.replace("MMMMM", "MM"); // month name long
        } else if (format.contains("MMMM")) {
            format = format.replace("MMMM", "MM"); // month name long
        } else if (format.contains("MMM")) {
            format = format.replace("MMM", "M"); // month name short
        } else if (format.contains("MM")) {
            format = format.replace("MM", "mm"); // month of year (two digit)
        }
        format = format.replace("yyyy", "yy");
        return format;
    };

    /* lookupLocalizedDateTimeFormat
     * Lookup the specified format given the user's locale settings and a fallback.
     *
     * @param <locale> the users (_jvselfUser) locale object
     * @param <format> date or time format that you want to use (shortDate, longDate, shortTime, longTime, shortTimestamp, longTimestamp)
     * @param <fallbackFormat> Java-style date or time format you want to fallback to or use literally
     * @return <String> Return a Java-style date or time format
       ===========================================================================*/
    jvFilterService.lookupLocalizedDateTimeFormat = function (locale, formatName, fallbackFormat) {
        // Only return the filters dateTime if there is a dateTime and format to format to
        var defaultShortDateFormat = 'MM/dd/yyyy';
        var defaultLongDateFormat = 'MMMM dd, yyyy';
        var defaultShortTimeFormat = 'h:mm a';
        var defaultLongTimeFormat = 'HH:mm:ss';
        var defaultShortTimestampFormat = defaultShortDateFormat + ' ' + defaultShortTimeFormat;
        var defaultLongTimestampFormat = defaultLongDateFormat + ' ' + defaultLongTimeFormat;
        var dateFormat = defaultShortDateFormat;

        var localizationSupport = (locale ? locale.localizationSupport : false);
        var localizationFeatureEnabled = (localizationSupport &&
                (localizationSupport.search('DATES_AVAILABLE') >= 0 || localizationSupport.search('ON') >= 0));
        if (!localizationFeatureEnabled && fallbackFormat) {
            return fallbackFormat;
        }

        if (formatName) {
            // Update the pattern based on the format provided
            // Gets the format from localizationUtil if set, of fallbacks back to
            // provided fallback or system default
            switch (formatName) {
            case 'shortDate':
                var shortDateFormat = locale.userDate.shortDate();
                dateFormat = shortDateFormat ? shortDateFormat : (fallbackFormat ? fallbackFormat : defaultShortDateFormat);
                break;
            case 'longDate':
                var longDateFormat = locale.userDate.longDate();
                dateFormat = longDateFormat ? longDateFormat : (fallbackFormat ? fallbackFormat : defaultLongDateFormat);
                break;
            case 'longDateWithDOW':
                var longDateFormat = locale.userDate.longDate();
                dateFormat = longDateFormat ? longDateFormat : (fallbackFormat ? fallbackFormat : defaultLongDateFormat);
                dateFormat = 'EEEE, '+ dateFormat;
                break;
            case 'shortTime':
                var shortTimeFormat = locale.userTime.shortTime();
                dateFormat = shortTimeFormat ? shortTimeFormat : (fallbackFormat ? fallbackFormat : defaultShortTimeFormat);
                break;
            case 'longTime':
                var longTimeFormat = locale.userTime.longTime();
                dateFormat = longTimeFormat ? longTimeFormat : (fallbackFormat ? fallbackFormat : defaultLongTimeFormat);
                break;
            case 'shortTimestamp':
                var shortTimeStampFormat = locale.userTimestamp.shortTimestamp();
                dateFormat = shortTimeStampFormat ? shortTimeStampFormat : (fallbackFormat ? fallbackFormat : defaultShortTimestampFormat);
                break;
            case 'longTimestamp':
                var longTimeStampFormat = locale.userTimestamp.longTimestamp();
                dateFormat = longTimeStampFormat ? longTimeStampFormat : (fallbackFormat ? fallbackFormat : defaultLongTimestampFormat);
                break;
            case 'literal':
                dateFormat = (fallbackFormat ? fallbackFormat : defaultShortDateFormat);
                break;
            default:
                break;
            }
        }
        return dateFormat;
    };

    return jvFilterService;
}])

/*
Pad
---
Pad a number to a specific number of characters.
Defaults to 2, and pads with 0.

### Usage
```
<span>{{ user.length | pad:3 }}</span>
```

will result in something like

```
<span>023</span>
```
 */
.filter('pad', function() {
    return function(input, padLen, padChar) {
        padLen = padLen || 2;
        padChar = padChar || '0';
        var pad = new Array(1+padLen).join(padChar);

        return (pad + input).slice(-pad.length);
    };
})

/*
StandardDate
------------
Format a date in a standard format.
 */
.filter('standardDate', ['$filter', function($filter) {
    return function(input) {
        return $filter('date')(input, 'yyyy-MM-dd');
    }
}])

//Filter to get the time in milliseconds. Given a dateString, it will convert to milliseconds.
.filter('getTimeInMilliseconds', ['$filter', function($filter) {
    return function(input) {
        var d = new Date(input);
        return d.getTime();
    }
}])

//filter to separate the values by separator.
.filter('FormatValuesBySeparator', function() {
    return function(items, key, separator) {
        if(angular.isArray(items) && angular.isString(key)){
            return items.map(function(item){
                return item[key];
            }).join( separator || ', ');
        }
    };
})

.filter('formatElapsedTime', ['$filter', function($filter){
	return function(durationInSeconds){
		if (durationInSeconds <0){
			durationInSeconds = 0;
		}
		var durationTime = new Date('1/1/2000'); //predefined date
		durationTime.setSeconds(durationInSeconds);
		return $filter('date')(durationTime, 'mm:ss');
	}
}])

//Filter which takes the date in string, converts it into milliseconds and then sends it over to the localeDateTime filter which
//converts the time in the user's timezone format.
.filter('localeDateTimeMilliseconds', ['$filter', function($filter) {
    return function(dateTime, formatName, fallbackFormat) {
        return $filter('localeDateTime')($filter('getTimeInMilliseconds')(dateTime), formatName, fallbackFormat);
    }
}])

/* ===========================================================================
    localeDateTime
    * Return a date or time format based on the users options.
    *
    * @param dateTime - a <Number / String / Date / undefined> representing the data of the display date (may include '-' as a legacy display literal)
    * @param formatName - a <String> date or time format that you want to use (shortDate, longDate, shortTime, longTime, shortTimestamp, longTimestamp, literal)
    * @param fallbackFormat - a <String> that represents the hardcoded fallback (optional)
    * @return <String> Return the formatted date or time
    ========================================================================== */
.filter('localeDateTime', ['$filter', '$window', 'jvFilterService', function ($filter, $window, jvFilterService) {
    return function (dateTime, formatName, fallbackFormat, onlyConvertDateFormat, companyLocale) {
        //This should never happen, unless client has issues downloading moment.js or moment-tz.js. Noticing these errors in logs
        //and this is just to make sure we do not process, if the library is not present. This is a defensive check and the
        //actual issues needs to be fixed in script loading dependency.
        if (typeof moment === "undefined" || typeof moment.tz === "undefined") {
            return dateTime;
        }

        //SUPPORT-9930: Date's locale cannot be initialized properly if there is no date type column in Candidate List
        //Create the dateTime as a dummy date for the date's locale initialization only.
        var forLocaleInit = false;
        var originalDateTime;
        if ((!angular.isDate(dateTime) && !angular.isNumber(dateTime) && !angular.isString(dateTime)) || angular.equals(dateTime,'-') || angular.equals(dateTime,'')) {
            originalDateTime = dateTime;
            forLocaleInit = true;
            dateTime = new Date();
        }

        var locale = null;
        //If company datetime preferences are passes to filter, should take high priority else fallback to User's preference
        if(!companyLocale){
            if ($window && $window._jvselfUser) {
                locale = $window._jvselfUser.locale;
            } else if (window && window._jvselfUser) {
                locale = window._jvselfUser.locale;
            }
        }else{
            locale = angular.extend({}, window._jvselfUser.locale, companyLocale);
        }

        var localizationSupport = (locale ? locale.localizationSupport : false);
        var localizationFeatureEnabled = (localizationSupport &&
                (localizationSupport.search('DATES_AVAILABLE') >= 0 || localizationSupport.search('ON') >= 0));

        // This check/modification needs to be examined in detail to ensure correct operation
        // business date of type string(eq:'06/10/2016') should not be transformed to local timezone
        // hence adding this !onlyConvertDateFormat to avoid converting datetime into User's timezone datetime. LOC: 220 will take care of formatting
        if (angular.isString(dateTime) && !onlyConvertDateFormat) {
            //dateTime = new Date(dateTime);
            dateTime = moment(moment.tz(dateTime, locale.timezone).format('YYYY-MM-DDTHH:mm:ss'));
            dateTime = dateTime.toDate();
        }
        var dateTimeInMillis = (angular.isDate(dateTime) ? dateTime.getTime() : dateTime);
        /*When the date conversion in user's timezone is not required,
        this will set user's Timezone offset to moment object*/
        var momentClone = moment(dateTimeInMillis).clone();
        if(onlyConvertDateFormat){
            var tzOffset = moment.tz(new Date(), locale.timezone).format('Z');
            momentClone.utcOffset(tzOffset);
            momentClone.add(moment(dateTimeInMillis).utcOffset() - momentClone.utcOffset(), 'minutes');
        }

        // Set the correct language for the date formatting
        moment.locale("en");
        if ((localizationSupport.search('LOCALES_AVAILABLE') >= 0 || localizationSupport.search('ON') >= 0)) {
            // NOTE: IIBN-515 Needs this updated to use the correct setting!!
            if (moment && moment.locale) {
                if(locale.language !== "zh") {
                    moment.locale(locale.language);
                } else {
                    if(locale.languageTag === "zh-HK") {
                        //In Jobvite, we have locales for Chinese languages: "zh-CN" for Mainland China, and "zh-HK" for HongKong.
                        //In moment framework, there are two locales for Chinese languages: "zh-CN" and "zh-TW", and no defined for "zh" and "zh-HK".
                        //Both HongKong and TaiWan use Traditional Chinese which is declared as "zh-TW", so we use "zh-TW" for HongKong.
                        moment.locale("zh-TW");
                    } else {
                        //Use "zh-CN" to get the locale for Simplified Chinese instead of "zh".
                        moment.locale(locale.languageTag);
                    }
                }
            }
        }

        var defaultTimezone = 'America/Los_Angeles'; // This default must match the server process timezone!
        var tzName = locale.timezone ? locale.timezone : defaultTimezone;
        var javaDateFormat = jvFilterService.lookupLocalizedDateTimeFormat(locale, formatName, fallbackFormat);

        //Moment.js needs times in a certain format else it displays incorrectly.
        //To accommodate that, we will ensure that whatever backend sends is converted to right format.
        var momentDateFormat = jvFilterService.convertJavaFormatToMomentFormat(localizationFeatureEnabled ? javaDateFormat : fallbackFormat);
        //onlyConvertDateFormat flag returns a formatted date in the users preferred date format without doing a conversion in the users timezone.
        //Else it returns a formatted date in the users preferred date format with a conversion in the users timezone.
        var formattedDate = onlyConvertDateFormat ? momentClone.format(momentDateFormat) : moment.tz(dateTimeInMillis, tzName).format(momentDateFormat);
        if(forLocaleInit) {
            return originalDateTime;
        } else {
            return formattedDate;
        }
    }
}])

.filter('exampleDate', ['$filter', function($filter) {
    return function(dateTime, dateFormat, removeFormat) {
        if (!dateFormat) {
            return dateFormat;
        }
        var filteredDate = $filter('localeDateTime')(dateTime, 'literal', dateFormat, true, window.locale);
        if(!removeFormat){
            // pad every datetime and format by specific number of spaces as (CHAR=1.85*space) APPROX
            // @TODO: Repace this logic to get max length from list of Supported Datetime Formats, Assuming 18 now.
            // 10: space between maximum length datetime and Format ie. 03:14:15 PM +03:00          (HH:MM:SS A Z)
            var spaceInDateAndFormat = 10 + Math.abs((18-filteredDate.length) * 1.85);
            for(var i=0; i< spaceInDateAndFormat; i++){
                filteredDate+= String.fromCharCode(160);
            }
            filteredDate += '(' + $filter('uppercase')(dateFormat) + ')';
        }
        return filteredDate;
    };
}])

.filter('parseInt', ['$filter', function( $filter ) {
    return function(input) {
        return parseInt(input);
    }
}])
.filter('length', function() {
    return function(value) {
        return value.length;
    };
})
// TODO: Compatibility fix so I don't have to make 2 quickview files. SHOULD BE REMOVED!!!
.filter('html', function() {
    return function(value) {
        return value;
    };
})
.filter('binaryPrefix', function (){
    return function(value) {
        var newVal;

        if(value > 0)
        {
            newVal = value/1000;
            if(value > 999 && value < 10000)
            {
                return (newVal.toFixed(1) + "k");
            }
            else if(value >= 10000)
            {
                return (newVal.toFixed(0) + "k");
            }
        }
        return value;
    };
})
.filter('newLine', function(){
    return function(text){
        if (text){
            return text.replace(new RegExp('\n','g'),'<br/>');
        }else{
            return text;
        }
    };
})
.filter('removeNewLines', function(){
    return function(text){
        if (text){
            return text.replace(new RegExp('\n','g'),' ');
        }
        return text;
    };
})
/**
 * Filter when applied to the input will truncate the contents of the input to an ellipses with
 * a limit of max 75 characters returning with the ellipses.
 * eg.
 * "The quick brown fox jumps right over the lazy..."
 * VA: TODO: change the name in the app to truncate instead of trim
 */
.filter('truncateContent', function(){
    var maxLength = 75;
    return function(input, length){
        // 75 characters.
        maxLength = length || maxLength;
        if(typeof input != "string" || input.length <= maxLength ){
            return input;
        }
        return input.substr(0,maxLength) + "...";
    };
})
/**
 * Filter when applied to the input will truncate the contents of the input to an ellipses with
 * a limit of length of the characters specified in the arguments along with the ellipses.
 */
.filter('truncateContentToLength', function(){
    return function(input, length){
        if(typeof input != "string" || input.length <= length ){
            return input;
        }
        return input.substr(0,length) + "...";
    };
})
/**
 * Filter when applied to the input will terminate the white spaces from the front and
 * the end of the input.
 */
.filter('trim', function(){
    return function( input ){
        return $.trim(input);
    };
})

.filter('upperCase', function(){
    return function(input) {
        if(input){
            return input.toUpperCase();
        }
        return input;
    };
})

.filter('encodeTags', function(){
    return function(input){
        if(input){
            input = input.replace(new RegExp('<','g'),'&lt;');
            input = input.replace(new RegExp('>','g'),'&gt;');
        }
        return input;
    }
})

.filter('formatNumber', function() {
    // TODO: add polyfill to improve support https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString#Browser_compatibility
    var supported = !!(typeof Intl == 'object' && Intl && typeof Intl.NumberFormat == 'function');
    return function(input, format) {
        if (!supported || !input || !input.toLocaleString) {
            return input;
        }
        if (!format) {
            format = (window._jvselfUser && _jvselfUser.locale && _jvselfUser.locale.languageTag) ? _jvselfUser.locale.languageTag : 'en-US';
        }
        return input.toLocaleString(format);
    }
})

.filter('objectFilter', function(){
    return function(input, query){
        if(!query) return input;
        var result = {};
        utils = {
                compareStr: function(stra, strb){
                    stra = ("" + stra).toLowerCase();
                    strb = ("" + strb).toLowerCase();
                    return stra.indexOf(strb) !== -1;
                }
        }
        angular.forEach(input, function(value,key){
            if(utils.compareStr(key, query))
                //var obj = {key:value};
                result[key] = value;
        });
        return result;
    };
})
.filter('replaceNewLine', function(){
    return function(text){
        //Detecting if content contains HTML so that it will not replace \n with <br/> since tinyMCE automatically adds <br/> with in editor.
        var pattern=/<(\w+)((?:\s+\w+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/gi;
        if(text && !text.match(pattern)){
            return text.replace(new RegExp('\\r?\\n','g'),'<br/>');
        }else{
            return text;
        }
    };
})
.filter('trim', function(){
    return function(text){
        if(text){
            if(typeof text === 'string'){
                return text.trim();
            }
        }
        return text;
    };
})
.filter('parseUnsafeHTML', ['$sce', function($sce) {
    return $sce.trustAsHtml;
}])
.filter('noHTML', function () {
    return function(text) {
        if (text) {
            return text
                 .replace(/&/g, "&amp;")
                 .replace(/</g, "&lt;")
                 .replace(/>/g, "&gt;")
                 .replace(/"/g, "&quot;")
                 .replace(/'/g, "&#039;");
        }
        return text;
    }
})
.filter('unique', function() {
    return function(input, property) {
        var keys = {};
        return input.filter(function(item){
            var key = (property? item[property] : item);
            if (!keys[key]) {
                keys[key] = 1;
                return true;
            }
            return false;
        });
    };
})
/**
 * codify: sanitize a string for use as a token or slug
 */
.filter('codify', function() {
    return function(input) {
        if (input == null) {
            return '';
        }

        return input.trim().replace(/\s\s+/g, ' ').replace(/\s/g, '_').replace(/\W/g, '').toLowerCase();
    }
})
/**
 * Escape single quote characters.
 */
.filter('escapequotes', function(){
    return function(text) {
         return text.replace(/'/g, '&#39;');
        };
})

.filter('formatYesNo', function(){
    return function(arg) {
        return arg === true ? (i18n['Yes'] || 'Yes') : (i18n['No'] || 'No');
    }
})
/**
 *  filter for getting custom or pre-configured meeting rooms
 */
.filter('filterObjects', function(){
    return function(input, property, flag) {
        var negation = flag || false;
        return input.filter(function(item){
            if (negation) {
                return property in item && !item[property];
            } else {
                return property in item && item[property];
            }
        });
    }
})
/**
* @method stringifyJSONForUISelect2
* @description Fix for IE11 - Ui-select2 value getting passed as object object
* @params {object} data - data to be stringified
*/
.filter('stringifyJSONForUISelect2', function(){
    return function(data) {
        if (navigator.userAgent.match(/msie/i) || navigator.userAgent.match(/trident/i) ){
            return JSON.stringify(data);
        }
        return data;
    };
})

/**
 * @method getProperTimeFormat
 * @description Fix for GAMMA-1021 -Video Issues - Date formatting in Preview / Format the timing to mm:ss
 * @param timeInMilliseconds - time in seconds and Integer form for example .
 * if time is 75(minute) then input for this method will be 75 *1000 = 75000
 * usage: used in previewVideoInterviewModal.jsp
 **/
.filter('getProperTimeFormat',function (){
    return function (timeInMilliseconds){
        var _minutes = parseInt(timeInMilliseconds / 60000, 10);
        var _seconds = timeInMilliseconds % 60000;
        if (_minutes < 10) {
            _minutes = '0' + _minutes;
        }
        _seconds = _seconds / 1000;
        if (_seconds < 10) {
            _seconds = '0' + _seconds;
        }
        return _minutes + ':' + _seconds;
    };
})
;
